import React, { useState } from "react";
import "./Contact.css";
import TopNavbar from "../../components/TopNavbar/TopNavbar";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import { Notify } from "notiflix";
import axios from "axios";
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    mobileNumber: "",
  });
  const [Loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    let newErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!/^[A-Za-z\s]+$/.test(formData.name)) {
      newErrors.name = "Name should contain only letters";
    }

    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    // Mobile Number validation (10 digits for India, adjust as needed)
    if (!formData.mobileNumber.trim()) {
      newErrors.mobileNumber = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.mobileNumber)) {
      newErrors.mobileNumber = "Enter a valid 10-digit mobile number";
    }

    // Message validation
    if (!formData.message.trim()) {
      newErrors.message = "Message cannot be empty";
    } else if (formData.message.length < 2) {
      newErrors.message = "Message should be at least 2 characters long";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0; // true if no errors
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoader(true)
      const data = {
        name: formData.name,
        email: formData.email,
        mobile_number: formData.mobileNumber,
        message: formData.message
      }
      axios.post('https://kovaikongunadumatrimony.com/kkm_backend/public/api/contact-us-message', data).then(res => {
        if (res.data.status == true) {
          setLoader(false)
          Notify.success(res.data.message)
          const whatsappMessage = `
    Contact Request Submitted ✅

    👤 Name: ${formData.name}
    📧 Email: ${formData.email}
    📱 Mobile: ${formData.mobileNumber}
    💬 Message: ${formData.message}
        `;

          // encode message for URL
          const encodedMessage = encodeURIComponent(whatsappMessage);

          const phoneNumber = "9965305393";

          // WhatsApp deep link
          const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
          window.open(whatsappURL, "_blank");

          // reset form
          setFormData({ name: "", email: "", message: "", mobileNumber: "" });
          setErrors({});

        } else {
          setLoader(false)
          Notify.failure(res.data.message)
        }
      })

    }
  };

  return (
    <>
      <TopNavbar />
      <Navbar />
      <div className="contact-container">
        <div className="contact-card">
          <h2 className="contact-title">Contact Us</h2>
          <p className="contact-subtitle">
            We'd love to hear from you! Fill out the form and we’ll get back soon.
          </p>

          <form className="contact-form">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && <span className="error">{errors.name}</span>}

            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <span className="error">{errors.email}</span>}

            <input
              type="tel"
              name="mobileNumber"
              placeholder="Your Mobile Number"
              value={formData.mobileNumber}
              onChange={handleChange}
            />
            {errors.mobileNumber && (
              <span className="error">{errors.mobileNumber}</span>
            )}

            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
            {errors.message && <span className="error">{errors.message}</span>}

            <button onClick={handleSubmit} type="button" disabled={Loader} className="contact-btn">
              {Loader ? "Loading..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
